"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _lodash = require("lodash");

var _menu = require("../utils/menu");

var _requester2 = _interopRequireDefault(require("./requester"));

var _constant = require("../constant");

var _common = require("../utils/common");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * 数据管理的删除扩展类
 */
var DeleteRequester = /*#__PURE__*/function (_requester) {
  (0, _inherits2["default"])(DeleteRequester, _requester);

  var _super = _createSuper(DeleteRequester);

  function DeleteRequester() {
    (0, _classCallCheck2["default"])(this, DeleteRequester);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(DeleteRequester, [{
    key: "deleteAllDataDetail",

    /**
     * 获取多条主表数据的table树数据
     * @param {*} oldData
     * @param {*} objectId 暂时用兼容老的组件使用，如果传递了objectId，则只删除当前条
     */
    value: function () {
      var _deleteAllDataDetail = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(oldList, objectId) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!objectId) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return this.wujiApi.deleteDataDetail(this.tableTree, {
                  objectId: objectId
                });

              case 3:
                return _context.abrupt("return");

              case 4:
                // 基于旧数据，得到一颗还原后包含数据的table树
                this.regainTableTreeByDataTree(oldList, this.tableTree); // 对table树中不再引用的数据，优先递归解绑关联键值

                this.setNotDependDataByTable(this.tableTree);
                _context.next = 8;
                return this.saveDataForDelete();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function deleteAllDataDetail(_x, _x2) {
        return _deleteAllDataDetail.apply(this, arguments);
      }

      return deleteAllDataDetail;
    }() // ---------------------------------------------

    /**
     * 对table树中不再引用的数据编辑删除 or 解除关联
     * @param {*} table table实例
     * @param {*} parentRelationObj 当前table与父节点的关系
     * @param {*} parentTable 父table实例
     */

  }, {
    key: "setNotDependDataByTable",
    value: function setNotDependDataByTable(table, parentRelationObj, parentTable) {
      var _this = this;

      var that = this;
      var dataList = table.dataList,
          extendTableInfo = table.extendTableInfo; // 非根节点的才解除关联

      if (parentRelationObj && parentTable) {
        var relation = parentRelationObj.relation;

        var _relation = (0, _slicedToArray2["default"])(relation, 3),
            relation0 = _relation[0],
            relation1 = _relation[1],
            relation2 = _relation[2];

        dataList.forEach(function ($data) {
          var data = $data;

          if (!data.__isDepend) {
            // 普通关联的键在子表、普通关联的键在父表
            if (relation1 === _menu.RelationStatus.RIGHT || relation1 === _menu.RelationStatus.LEFT) {
              // 父数据若存在不要删除的，则此数据不能动
              var result = parentTable.dataList.find(function (parentData) {
                return !parentData.__isDepend && parentData.__changeType !== _menu.DataStatus.DELETE && parentData[relation0] === data[relation2];
              });

              if (!result) {
                // 声明不保留，则标记要删除
                if (!extendTableInfo.isKeep) {
                  data.__changeType = _menu.DataStatus.DELETE;
                }
              }
            } // 反向关联link的键在子表:自己负责存储关联键值


            if (relation1 === _menu.RelationStatus.IN) {
              // 解除父数据中已要删除数据的关联
              var linkValues = data[relation2].split(_constant.LINKSPLIT);
              parentTable.dataList.forEach(function (parentData) {
                // 过滤掉要删除的父数据的关联键引用
                if (!parentData.__isDepend && parentData.__changeType === _menu.DataStatus.DELETE) {
                  linkValues = linkValues.filter(function (link) {
                    return link !== "".concat(parentData[relation0]);
                  });
                }
              });
              var obj = {};
              obj[relation2] = linkValues.join(_constant.LINKSPLIT); // 说明关联link的值有改变

              if (data[relation2] !== obj[relation2]) {
                _this.setEditState(data, obj);
              } // 如若关联都被清空了 + 声明不保留，则标记要删除


              if (!obj[relation2] && !extendTableInfo.isKeep) {
                data.__changeType = _menu.DataStatus.DELETE;
              }
            } // 反向关联link的键在父表：自己不存储关联键值


            if (relation1 === _menu.RelationStatus.INCLUDE) {
              // 父数据若存在不要删除的，则此数据不能动
              var _result = parentTable.dataList.find(function (parentData) {
                return !parentData.__isDepend && parentData.__changeType !== _menu.DataStatus.DELETE && (parentData[relation0] || '').split(_constant.LINKSPLIT).indexOf(data[relation2]) > -1;
              });

              if (!_result) {
                // 声明不保留，则标记要删除
                if (!extendTableInfo.isKeep) {
                  data.__changeType = _menu.DataStatus.DELETE;
                }
              }
            }

            ;
          }
        });
      } else {
        dataList.forEach(function ($data) {
          var data = $data;

          if (!data.__isDepend) {
            // 则标记为删除
            data.__changeType = _menu.DataStatus.DELETE;
          }
        });
      }

      if (table.forkTableList.length > 0) {
        table.forkTableList.forEach(function (forkTableObj) {
          var relationObj = forkTableObj.relationObj,
              forkTable = forkTableObj.forkTable;
          that.setNotDependDataByTable(forkTable, relationObj, table);
        });
      }
    } // ---------------------------------------------

    /**
     * 对table树的处理后不再关联数据的处理
     */

  }, {
    key: "saveDataForDelete",
    value: function () {
      var _saveDataForDelete = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var that, allPromise;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = this;
                allPromise = [];
                this.rawTableList.forEach(function (table) {
                  var dataList = table.dataList,
                      extendTableInfo = table.extendTableInfo;
                  var deleteType = extendTableInfo.deleteType,
                      deleteField = extendTableInfo.deleteField,
                      deleteValue = extendTableInfo.deleteValue;
                  dataList.forEach(function (data) {
                    if (!data.__isDepend) {
                      if (data.__changeType === _menu.DataStatus.DELETE) {
                        if (deleteType === 1) {
                          allPromise.push(that.wujiApi.deleteDataDetail(table, {
                            objectId: data[table.primaryKey]
                          }));
                        } else {
                          var editData = {};
                          editData[table.primaryKey] = data[table.primaryKey];
                          editData[deleteField] = deleteValue;
                          allPromise.push(that.wujiApi.editDataDetail(table, editData));
                        }
                      } else if (that.hasChangeForData(data)) {
                        var _editData = (0, _lodash.cloneDeep)(data.__changeFields);

                        _editData[table.primaryKey] = data[table.primaryKey];
                        allPromise.push(that.wujiApi.editDataDetail(table, _editData));
                      }
                    }
                  });
                });
                _context2.next = 5;
                return (0, _common.allSettled)(allPromise);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function saveDataForDelete() {
        return _saveDataForDelete.apply(this, arguments);
      }

      return saveDataForDelete;
    }()
    /**
     * 设置数据的编辑状态
     * @param {*} $data
     * @param {*} changeObj
     */

  }, {
    key: "setEditState",
    value: function setEditState($data, changeObj) {
      var data = $data;
      data.__changeType = _menu.DataStatus.EDIT;
      data.__changeFields = Object.assign(data.__changeFields || {}, changeObj);
    }
    /**
     * 判断存在__changeFields，是否真的要操作无极api
     * @param {*} data
     */

  }, {
    key: "hasChangeForData",
    value: function hasChangeForData(data) {
      var change = false;

      if (data.__changeFields) {
        var changeData = data.__changeFields;
        Object.keys(changeData).forEach(function (key) {
          if (changeData[key] !== undefined) {
            change = true;
          }
        });
      }

      return change;
    }
  }]);
  return DeleteRequester;
}(_requester2["default"]);

var _default = DeleteRequester;
exports["default"] = _default;